define('components/handlers',[
    'jquery',
    'components/decorator',
    'components/util/tool-menu',
    'components/util/reload-fragments',
    'components/util/social-share',
    'components/handlers/analytics',
    // add
    'components/handlers/follow-query',
    'components/handlers/filters'
], function($, decorator, toolMenu, reload, socialShare, analytics) {

    $.extend(companyInfo.handlers, {

        'tab-link': function(e) {
            $(this).parent().siblings().find('a').removeClass('selected-link');
            $(this).addClass('selected-link');

            $($(this).attr('href')).removeClass('unselected-tab').siblings('div').addClass('unselected-tab').parent().addClass('ie8fix');
            decorator.run($(this).closest('.panel'));
            e.preventDefault();
        },

        /**
         * Requires data-selector attribute on element.
         * @param e
         */
        'toggle-checkbox': function(e){
            $($(this).data('selector')).prop("checked",this.checked);
        },
        'toggle-checkbox-submit': function(e){
            // $($(this).data('selector')).prop("checked",this.checked);
            e.preventDefault();
            var form =  $(this).closest("form");
            $('<input />').attr('type', 'hidden')
                .attr('name', "resend")
                .attr('value', "true")
                .appendTo(form);
            form.submit();
        },

        'toggle-text': function(e) {
            var tmp;
            if ($(this).find('span').length) {
                tmp = $.trim($(this).find('span').text());
                $(this).find('span').text($(this).attr('data-toggle-text'));
            } else {
                tmp = $.trim($(this).text());
                $(this).text($(this).attr('data-toggle-text'));
            }
            $(this).attr('data-toggle-text', tmp);
        },

        'toggle-icon': function(e) {
            var tmp = $(this).find('i')[0].className;
            $(this).find('i')[0].className = $(this).attr('data-toggle-icon');
            $(this).attr('data-toggle-icon', tmp);
        },

        'toggle-filter': function(e) {
            $(this).nextAll('.column-filter').toggle();
        },

        'toggle-class': function(e){
            $(this).toggleClass(this.getAttribute('data-class'));
        },

        'toggle-menu': function(e) {
            $(this).toggleClass('menu-active');
            e.preventDefault();
            e.stopPropagation();
        },

        'toggle-submenu': function(e) {
            var toggle = !$(this).hasClass('submenu-active');
            $('.submenu-active').removeClass('submenu-active');
            $(this).toggleClass('submenu-active', toggle);
            e.preventDefault();
            e.stopPropagation();
        },

        'close-menus': function(){
            $('.submenu-active,.menu-active').removeClass('submenu-active').removeClass('menu-active');
        },

        'open-kvk-link': function(e) {
            window.open(this.getAttribute('data-url'), '_blank');
        },

        'open-popup': function(e) {
            window.open(this.href, '_blank', 'width=800,height=400,scrollbars=1');
            e.preventDefault();
        },

        'print': function(e) {
            window.print();
            e.preventDefault();
        },

        'confirm': function(e) {
            if (!window.confirm(this.getAttribute('data-confirm'))) {
                e.preventDefault();
            }
        },

        'confirm-delete-multiple': function(e) {
            var checked = $(this).closest('table').find('thead tr, tfoot tr').find('[name=checkboxAll]').prop('checked');
            if (checked && this.getAttribute('data-confirm-all') !== null && !confirm(this.getAttribute('data-confirm-all'))) {
                $('[name=checkboxAll]').prop('checked', false);
                e.preventDefault();
            } else if (!checked && this.getAttribute('data-confirm') !== null && !confirm(this.getAttribute('data-confirm'))) {
                e.preventDefault();
            }
        },

        'print-frame': function(e) {
            var frameID = this.getAttribute('data-frame') || 'frame';
            var frame = document.getElementById(frameID);
            if (frame && frame.contentWindow) {
                frame.contentWindow.focus();
                frame.contentWindow.print();
            } else {
                window.print();
            }
            e.preventDefault();
        },

        // formerly known as favorite.
        'follow': function(e) {
            var key = this.getAttribute('data-follow-key');
            var url = this.getAttribute('data-follow-url');
            var icon = $(this).find('i');
            icon.addClass('ico-spinner ico-spin');
            $.ajax({
                url: url + key,
                type: 'GET',
                cache: false
            }).done(function(result){
                if ('added' == result) {
                    icon.removeClass('ico-heart-o').addClass('ico-heart');
                    analytics(['user settings', 'add to follow list', url + key]);
                } else if ('deleted' == result) {
                    icon.removeClass('ico-heart').addClass('ico-heart-o');
                    analytics(['user settings', 'remove from follow list', url + key]);
                }
                reload('follow');
            }).always(function(){
                icon.removeClass('ico-spinner ico-spin');
            });
        },

        'alert': function(e){
            e.preventDefault();
            var key = this.getAttribute('data-alert-key');
            var url = this.getAttribute('data-alert-url');
            var icon = $(this).find('i');
            icon.addClass('ico-spinner ico-spin');
            $.ajax({
                url: url + key,
                type: 'GET',
                cache: false
            }).done(function(result){
                if ('added' == result) {
                    icon.removeClass('ico-bell-o').addClass('ico-bell');
                    analytics(['user settings', 'activate alert', url + key]);
                } else if ('deleted' == result) {
                    icon.removeClass('ico-bell').addClass('ico-bell-o');
                    analytics(['user settings', 'deactivate alert', url + key]);
                }
            }).always(function(){
                icon.removeClass('ico-spinner ico-spin');
            });
        },

        'blacklist': function(e) {
            var key = this.getAttribute('data-blacklist-key');
            var url = this.getAttribute('data-blacklist-url');
            var icon = $(this).find('i');
            icon.addClass('ico-spinner ico-spin');
            $.ajax({
                url: url + key,
                type: 'GET',
                cache: false
            }).done(function(result){
                if ('added' == result) {
                    icon.removeClass('ico-flag-o').addClass('ico-flag');
                } else if ('deleted' == result) {
                    icon.removeClass('ico-flag').addClass('ico-flag-o');
                }
            }).always(function(){
                icon.removeClass('ico-spinner ico-spin');
            });
        },

        'toggle-visibility': function(e) {
            var target = this.getAttribute('data-selector') || $(this).attr('href');
            if ( target )  {
                $(target).toggle();
            } else {
                target = this.getAttribute('data-relative');
                if ( target == "next" ) {
                    $(this).next().toggle();
                } else if ( target == "previous" ) {
                    $(this).prev().toggle();
                } else if ( target == "parent" ) {
                    $(this).parent().toggle();
                }
            }
            if (e.target.tagName.toLowerCase() == 'a') {
                e.preventDefault();
            }
        },

        'hide-element': function(e) {
            var selector = this.getAttribute('data-selector') || $(this).attr('href');
            $(selector).hide();
            if (e.target.tagName.toLowerCase() == 'a') {
                e.preventDefault();
            }
        },

        'toggle-accordion-panel': function(e){
            $(this).closest('.accordion-panel').toggleClass('open');
        },

        'focus-field': function(e) {
            var selector = this.getAttribute('data-focus') || $(this).attr('href');
            if ($(selector).is(':visible')) {
                $(selector).focus();
            }
            e.preventDefault();
        },

        'login': function(e) {
            $('#login').removeClass('hidden').find('input:first').focus();
            e.preventDefault();
        },

        'forgot-password': function(e) {
            $('#login').addClass('hidden');
            $('#forgot-password').removeClass('hidden').find('input:first').focus();
            e.preventDefault();
        },

        'close-overlay': function(e) {
            $(this).closest('.as-overlay').addClass('hidden');
            e.preventDefault();
        },

        'share': function(e){
            socialShare.getInstance().toggleTooltip(this);
        },

        'total-values': function(e) {
            var ids = this.getAttribute('data-selector').split(/\s+/);
            var total = 0;
            for (var i = 0; i < ids.length; i++) {
                for (var j = 0; j < $(ids[i]).length; j++) {
                    var test = $(ids[i]).eq(j).val().replace(/\./gi, '');
                    test = test.replace(/\,/gi, '.');
                    var num = (test !== '' ? Number( test ) : 0);
                    total += num;
                }
            }
            var tot = '' + total;
            $(this).val(tot.replace(/\./gi, ','));
        },

        'date-change': function(e) {
            var input = $(this);
            var form = input.closest('#billingForm');

            form.find('.form-element strong').remove();
        }

    });

});

